module.exports = "<div three-js-view  class=\"model-container\">\n  <div class=\"model-view\"></div>\n</div>\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/model-view/model-view.html
// module id = 471
// module chunks = 0